import { formatDate } from '@/lib/dateFormat';

/** Capture-interval choices offered per person, in seconds. */
export const INTERVAL_CHOICES = [60, 120, 300, 600, 900, 1800];

export const intervalLabel = (secs: number): string => (secs < 60 ? `${secs}s` : `${secs / 60} min`);

/** "06 Apr 2026", or "06 Apr 2026 → 08 Apr 2026" for a range. */
export const rangeLabel = (start: string, end: string): string =>
  start === end ? formatDate(start) : `${formatDate(start)} → ${formatDate(end)}`;

const COUNT_FORMAT = new Intl.NumberFormat('en-IN');

/** Capture / screenshot counts with Indian digit grouping. */
export const formatCount = (n: number | null | undefined): string => COUNT_FORMAT.format(Number(n || 0));
